const BATCH_SIZE = 5;

export function dividirEmLotes<T>(items: readonly T[], batchSize: number): T[][] {
  if (batchSize < 1) return items.length > 0 ? [[...items]] : [];
  const lotes: T[][] = [];
  for (let i = 0; i < items.length; i += batchSize) {
    lotes.push(items.slice(i, i + batchSize));
  }
  return lotes;
}

export async function batchDispatch<T>(
  ids: string[],
  action: (id: string) => Promise<T>,
  batchSize: number = BATCH_SIZE,
): Promise<T[]> {
  const results: T[] = [];

  for (const chunk of dividirEmLotes(ids, batchSize)) {
    const chunkResults = await Promise.all(chunk.map(action));
    results.push(...chunkResults);
  }

  return results;
}
